export default __webpack_public_path__ + "static/media/subscriptionIcon.ffaffbaa.svg";